<section class="content">
  <div class="card" style="padding: 24px;">
  <div class="container">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
    <div class="row">
      <div class="col-4">
        <label>Select Month <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
        <mat-select class="main-border-class" [(ngModel)]="selected_month">
          <mat-option *ngFor="let month of month_list_for_last_12_months" [value]=month>
            {{month['month_in_string']}} - {{month['year']}}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-2">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 22%;border-radius: 5px;background: blanchedalmond;">Get</button>
      </div>
    </div>
    <br>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div *ngIf="is_data_available">
      <div class="table-responsive" *ngIf="total_sale_details!=null">
        <div class="row">
          <div class="col-6"></div>
          <div class="col-6">
            <div class="row">
              <div class="col-4">
                <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50"
                  *ngIf="!is_document_available">
                </mat-progress-spinner>
              </div>
              <div class="col-4">
                <button mat-button class="button-class" (click)="downloadReportCliked()"><i class="material-icons">
                    picture_as_pdf
                  </i> Download report</button>
              </div>
              <div class="col-4">
                <button mat-button class="button-class"><i class="material-icons">
                    get_app
                  </i> Download Excel</button>
              </div>
            </div>
          </div>
        </div>
        <br>
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Date</th>
              <th>Agent sales</th>
              <th>Card Sales</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let date of total_sale_details['date_list']; let counter_index=index">
              <td>{{counter_index + 1}}</td>
              <td>{{date}}</td>
              <td style="text-align: right;">{{total_sale_details[date]['agent_total_order'] | currency: 'INR'}}</td>
              <td style="text-align: right;">{{total_sale_details[date]['icus_total_order'] | currency: 'INR'}}</td>
              <td style="text-align: right;">
                {{total_sale_details[date]['agent_total_order'] + total_sale_details[date]['icus_total_order'] | currency: 'INR'}}
              </td>
            </tr>
            <tr>
              <td colspan="2" style="text-align: right;">Grand Total</td>
              <td style="text-align: right;">{{total_sale_details['total_agent_total'] | currency: 'INR'}}</td>
              <td style="text-align: right;">{{total_sale_details['total_icustomer_total'] | currency: 'INR'}}</td>
              <td style="text-align: right;">{{total_sale_details['grand_total'] | currency: 'INR'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  </div>
</section>
